import React, { useState, useEffect } from 'react';
import CommonModal from '../common/commonModal/CommonModal';
import { categoryCrud } from '../../api/category';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from "../../utils/constants/utilsConstants";
import validateFields from '../ValidationChecker';

const CategoryModal = ({ show, onHide, initialData, onSaveSuccess }) => {
    const [modalMode, setModalMode] = useState('add');
    const [modalData, setModalData] = useState({ category_name: '', category_code: '' });
    const [initialModalState, setInitialModalState] = useState({ category_name: '', category_code: '' });
    const [errors, setErrors] = useState({});
    const [isChanged, setIsChanged] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const columns = [
        { header: 'Category Name', accessor: 'category_name', type: 'text', required: true },
        { header: 'Category Code', accessor: 'category_code', type: 'text', required: true },
    ];

    useEffect(() => {
        if (show) {
            if (initialData && initialData.id) {
                setModalMode('edit');
                const data = {
                    id: initialData.id,
                    category_name: initialData.category_name || '',
                    category_code: initialData.category_code || '',
                };
                setModalData(data);
                setInitialModalState(data);
            } else {
                setModalMode('add');
                const emptyData = { category_name: '', category_code: '' };
                setModalData(emptyData);
                setInitialModalState(emptyData);
            }
            setErrors({});
            setIsChanged(false);
        }
    }, [show, initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setModalData((prev) => {
            const updated = { ...prev, [name]: value };
            setIsChanged(JSON.stringify(updated) !== JSON.stringify(initialModalState));
            return updated;
        });
    };

    const handleSave = () => {
        const validationFields = columns.map(c => ({ name: c.accessor, required: c.required }));
        const { isValid, errors: validationErrors } = validateFields(modalData, validationFields);

        if (isValid) {
            setIsSaving(true);
            const method = modalMode === 'add' ? 'post' : 'put';

            categoryCrud(modalData, method, (res) => {
                setIsSaving(false);
                if (res?.status === true || res?.status === 200) {
                    ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
                    if (onSaveSuccess) {
                        onSaveSuccess();
                    }
                    onHide();
                } else {
                    if (res?.data?.errors) {
                        setErrors(res?.data?.errors);
                    } else {
                        ReactNotifications(res?.data?.message || 'An error occurred', utilConstants.getErrorStatus);
                    }
                }
            });
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <CommonModal
            show={show}
            handleClose={onHide}
            handleSave={handleSave}
            mode={modalMode}
            columns={columns}
            data={modalData}
            handleChange={handleChange}
            errors={errors}
            isChanged={isChanged}
            isSaving={isSaving}
        />
    );
};

export default CategoryModal;
